import styled from 'styled-components'

export const MaxWidthContainer = styled.div`
  max-width: 1600px;
  margin: 0 auto;
`
